module.exports = __webpack_public_path__ + "img/ch12_04_烛光许愿.57706b60.jpg";